<!--
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-06-22 13:58:39
 * @LastEditors: 陈钊贤
 * @Description: 企业出现的
 * @LastEditTime: 2020-12-25 13:56:52
--> 
<template>
  <div class="pi-enterprise-text">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "pi-enterprise-text"
};
</script>
<style lang="less">
.pi-enterprise-text {
  background: rgba(255, 210, 152, 0.25);
  color: #666666;
  font-size: 0.24rem;
  line-height: 0.33rem;
  // height: 0.33rem;
  padding: 0.08rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
}
</style>